import React, { useContext, useState } from "react";
import classNames from "classnames";
import { Button, Tooltip, Modal } from "../components";
import { SolutionContext } from "./contexts";
import { Carousel } from "./components/Carousel";
export const App = () => {
    const { selectedTab, setSelectedTab, selectedSolution, tabs, footerContent } = useContext(SolutionContext);
    const [openModal, setOpenModal] = useState(false);
    const [selectedSolutionArea, setSelectedSolutionArea] = useState();
    const [selectedCategoryIndex, setSelectedCategoryIndex] = useState();
    const toggleModal = (item) => {
        setOpenModal(!openModal);
        setSelectedSolutionArea(item);
        setSelectedCategoryIndex(undefined);
    };
    if (!selectedSolution) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "solution-explore", style: { backgroundImage: `url(${selectedSolution.image})` } },
            selectedSolution.data.map((item) => (React.createElement(Tooltip, { key: item.slug, style: {
                    top: `${item.coordinates[0]}%`,
                    left: `${item.coordinates[1]}%`,
                }, tooltipContent: React.createElement(React.Fragment, null,
                    React.createElement("div", null, item.label),
                    React.createElement(Button, { type: "button", className: "tw-mt-4 tw-w-full tw-justify-center", onClick: () => {
                            toggleModal(item);
                        } }, "Explore")) },
                React.createElement("div", { className: "marker", onClick: () => {
                        toggleModal(item);
                    } })))),
            React.createElement("footer", null,
                tabs.length > 1 ? (React.createElement("nav", { className: "nav-tab nav-tab-categories" },
                    React.createElement("ul", null, tabs.map((tab, index) => (React.createElement("li", { key: tab.explore_item_api },
                        React.createElement("button", { type: "button", className: classNames({
                                "is-active": tab.explore_item_api === selectedTab.explore_item_api,
                            }), onClick: () => {
                                setSelectedTab(tab);
                                const tabPanes = document.querySelectorAll('.tab-pane');
                                tabPanes.forEach((tabPane) => {
                                    tabPane.classList.remove('show', 'active');
                                });
                                tabPanes[index].classList.add('show', 'active');
                            } }, tab.explore_item_label))))))) : null,
                React.createElement("p", null, footerContent)),
            React.createElement("div", { className: "solution-explore-overlay" },
                React.createElement("div", { className: "container" },
                    React.createElement("i", { className: "icon-maximize-2" }),
                    "Rotate your phone to view the Farm Visualiser"))),
        React.createElement(Modal, { isOpen: openModal, className: "modal-solutions", onClose: () => {
                setOpenModal(false);
            } }, selectedSolutionArea ? (React.createElement("div", { className: classNames({
                ["type-index"]: selectedCategoryIndex === undefined &&
                    selectedSolutionArea.categories.length > 0,
                ["type-show"]: selectedCategoryIndex !== undefined,
                ["type-article"]: selectedCategoryIndex === undefined &&
                    selectedSolutionArea.categories.length === 0,
                "modal-body": true,
            }) }, selectedCategoryIndex !== undefined ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "col-left" },
                React.createElement(Carousel, { enabled: selectedSolutionArea.categories[selectedCategoryIndex]
                        .images.length > 1, images: selectedSolutionArea.categories[selectedCategoryIndex]
                        .images }),
                React.createElement("footer", null,
                    selectedCategoryIndex > 0 ? (React.createElement("div", { className: "btn-prev" },
                        "Previous:",
                        React.createElement("button", { type: "button", onClick: () => {
                                setSelectedCategoryIndex(selectedCategoryIndex - 1);
                            } }, selectedSolutionArea.categories[selectedCategoryIndex - 1].label))) : null,
                    selectedCategoryIndex <
                        selectedSolutionArea.categories.length - 1 ? (React.createElement("div", { className: "btn-next" },
                        "Next:",
                        React.createElement("button", { type: "button", onClick: () => {
                                setSelectedCategoryIndex(selectedCategoryIndex + 1);
                            } }, selectedSolutionArea.categories[selectedCategoryIndex + 1].label))) : null)),
            React.createElement("div", { className: "col-right" },
                React.createElement("button", { className: "btn-back", onClick: () => {
                        setSelectedCategoryIndex(undefined);
                    } },
                    React.createElement("span", null, "Back"),
                    React.createElement("i", { className: "icon-corner-up-left" })),
                React.createElement("header", null,
                    React.createElement("ul", { className: "breadcrumb" },
                        React.createElement("li", null,
                            React.createElement("button", { type: "button", onClick: () => {
                                    setSelectedCategoryIndex(undefined);
                                } }, selectedSolutionArea.label)),
                        React.createElement("li", null,
                            React.createElement("i", { className: "icon-chevron-right" }),
                            selectedSolutionArea.categories[selectedCategoryIndex]
                                .label))),
                React.createElement("div", { dangerouslySetInnerHTML: {
                        __html: selectedSolutionArea.categories[selectedCategoryIndex]
                            .content,
                    } }),
                React.createElement("div", { className: "tw-mt-6" },
                    React.createElement(Button, { as: "a", href: selectedSolutionArea.categories[selectedCategoryIndex].btn_url, target: "_blank", size: "lg", className: "tw-justify-center tw-w-full tw-max-w-[290px]" }, selectedSolutionArea.categories[selectedCategoryIndex].btn_label))))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "col-left" },
                React.createElement(Carousel, { enabled: selectedSolutionArea.images.length > 1, images: selectedSolutionArea.images })),
            React.createElement("div", { className: "col-right" },
                React.createElement("header", null,
                    React.createElement("h2", null, selectedSolutionArea.label),
                    selectedSolutionArea.short_desc ? (React.createElement("p", null, selectedSolutionArea.short_desc)) : null),
                selectedSolutionArea.categories.length > 0 ? (React.createElement("ul", null, selectedSolutionArea.categories.map((category, index) => (React.createElement("li", { key: category.slug },
                    React.createElement("button", { type: "button", onClick: () => {
                            setSelectedCategoryIndex(index);
                        } },
                        category.label,
                        React.createElement("i", { className: "icon-chevron-right" }))))))) : null,
                selectedSolutionArea.content ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { dangerouslySetInnerHTML: {
                            __html: selectedSolutionArea.content,
                        } }),
                    React.createElement("div", { className: "tw-mt-6" },
                        React.createElement(Button, { href: selectedSolutionArea.btn_url, target: "_blank", size: "lg", className: "tw-justify-center tw-w-full tw-max-w-[290px]", as: "a" }, selectedSolutionArea.btn_label)))) : null))))) : null)));
};
